/**
 * @author Akshay Kumar Singh
 * @file ConfigurePlant Component
 * @flow
 */
import React, { useState, useEffect } from 'react';

import { spinnerService } from '../../shared/services/spinner.service';
import { CallApi } from '../../shared/services/api.service'
import CONFIG from '../../configuration/config';
import AlertModal from '../../shared/modals/AlertModal';
import Validator from '../../shared/validator'
import SubHeaderComponent from '../common/HeaderComponent/SubHeaderComponent';
import { LABLES, STRINGS } from '../../shared/constants/data';
import { useHistory } from "react-router-dom";

const ConfigurePlant = () => {

  const history = useHistory();
  const [plantArr, setPlantArr] = useState([]);
  const [plantId, setPlantId] = useState('');
  const [plantName, setPlantName] = useState('')
  const [directorName, setDirectorName] = useState('');
  const [plantType, setPlantType] = useState('');
  const [, forceUpdate] = useState();
  const [plantData, setPlantData] = useState({
    armaPlantId: '',
    plantName: '',
    plantCode: '',
    plantDirector: '',
    vlm: '',
    orgCode: ''
  });

  /**
   * @description This function is react life cycle hook which sets initial values whenever the component loads.
   */
  useEffect(() => {
    Validator.hideMessages();
    getPlantDataList();
  }, []);

  /**
   * @description This function fetch all plants data.
   */
  const getPlantDataList = async () => {
    spinnerService.show(LABLES.Oval, STRINGS.FetchPlant);
    await CallApi(LABLES.POST, CONFIG.plantList, {}, {}, '', getPlantList, history);
  }

  /**
   * @description Plant List API callback function
   * @param response This is the response structure received from API
   */
  const getPlantList = (response) => {
    if (response?.success) {
      setPlantArr(response.response.plant);
    }
  }

  /**
   * @description This function updates the plant details whenever the plant is selected from drop-down
   */
  useEffect(() => {
    plantArr.forEach(data => {
      if (data.plant_id === parseInt(plantId)) {
        setPlantName(data.plant_name);
        setDirectorName(data.plant_director);
        setPlantType(data.vlm)
      }
    })
  }, [plantId])

  /**
   * @description This function updates the details of of plant.
   */
  const handleUpdate = async (event, type) => {
    event.preventDefault();
    if (type === 1) {
      if (plantId) {
        const plantObj = {
          plant_id: plantId,
          plantDirector: directorName.trim(),
          vlm: plantType
        }
        spinnerService.show(LABLES.Oval, STRINGS.UpdatePlantDetails);
        await CallApi(LABLES.POST, CONFIG.updateVLM, {}, plantObj, '', updatePlant, history);
      } else {
        AlertModal.showAlert(STRINGS.SelectPlantUpdate)
      }
    }
    else if (type === 2) {
      const isValid = Validator.allValid();
      if (isValid) {
        Validator.hideMessages();
        spinnerService.show(LABLES.Oval, STRINGS.ADDNEWPLANT)
        await CallApi(LABLES.POST, CONFIG.addPlant, {}, plantData, '', addPlant, history);
      } else {
        Validator.showMessages();
        forceUpdate({})
        AlertModal.showAlert(STRINGS.AllFieldRequired);
      }
    }
  }

  const addPlant = (response) => {
    if (response.success)
      AlertModal.showAlert(response.response.message);
  }

  /**
   * @description UpdateVLM API callback function
   * @param response This is the response structure received from API
   */
  const updatePlant = (response) => {
    if (response.success) {
      AlertModal.showAlert(STRINGS.UpdatePlantSuccess)
      getPlantDataList();
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlantData({
      ...plantData,
      [name]: value
    })
  }

  return (
    <div className="plant-summary-wrapper">
      <SubHeaderComponent page={3} pageName={LABLES.PlantManagement} />
      <div className="super-admin super-admin-form">
        <label style={{ fontSize: "large" }}>{LABLES.UpdatePlant}</label><br /><br />
        <div className="form-row">
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.PlantList}</label>
              <select className="form-control" onChange={(e) => setPlantId(e.target.value)} name='plantId' value={plantId}>
                <option hidden value=''>{STRINGS.SelectPlant}</option>
                {plantArr.map((data, index) => {
                  return <option key={data.plant_id} value={data.plant_id}>{data.plant_name}</option>
                })
                }
              </select>
            </div>
          </div>
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.DirectorName}</label>
              <input type="text" value={directorName} className="form-control" onChange={(e) => setDirectorName(e.target.value)} placeholder={LABLES.DirectorName} readOnly={!plantId} />
            </div>
          </div>
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.PlantType}</label>
              <select className="form-control" onChange={(e) => setPlantType(e.target.value)} name='plantType' value={plantType} disabled={!plantId}>
                <option hidden value=''>{STRINGS.SelectType}</option>
                <option value='Yes'>{LABLES.VLM}</option>
                <option value='No'>{LABLES.NonVLM}</option>
              </select>
            </div>
          </div>
        </div>
        <div className="submition-outer"><button type='button' className="btn-prmry" onClick={(e) => handleUpdate(e, 1)}>{LABLES.UpdatePlant}</button></div>
      </div>
      <div className="super-admin super-admin-form">
        <label style={{ fontSize: "large" }}>{LABLES.ADDPLANT}</label><br /><br />
        <div className="form-row">
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.PlantId}</label>
              <input type="text" name="armaPlantId" value={plantData.armaPlantId} onChange={(e) => handleChange(e)} className="form-control" placeholder={LABLES.PlantId} />
              <div className='srv-validation-message'>{Validator.message('armaPlantId', plantData.armaPlantId, 'armaPlantId')}</div>
            </div>
          </div>
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.PlantName}</label>
              <input type="text" name="plantName" value={plantData.plantName} onChange={(e) => handleChange(e)} className="form-control" placeholder={LABLES.PlantName} />
              <div className='srv-validation-message'>{Validator.message('plantName', plantData.plantName, 'plantName')}</div>
            </div>
          </div>
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.PlantCode}</label>
              <input type="text" name="plantCode" value={plantData.plantCode} onChange={(e) => handleChange(e)} className="form-control" placeholder={LABLES.PlantCode} />
              <div className='srv-validation-message'>{Validator.message('plantCode', plantData.plantCode, 'plantCode')}</div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.DirectorName}</label>
              <input type="text" name="plantDirector" value={plantData.plantDirector} onChange={(e) => handleChange(e)} className="form-control" placeholder={LABLES.DirectorName} />
              <div className='srv-validation-message'>{Validator.message('plantDirector', plantData.plantDirector, 'plantDirector')}</div>
            </div>
          </div>
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.PlantType}</label>
              <select className="form-control" onChange={(e) => handleChange(e)} name='vlm' value={plantData.vlm}>
                <option hidden value=''>{STRINGS.SelectType}</option>
                <option value='Yes'>{LABLES.VLM}</option>
                <option value='No'>{LABLES.NonVLM}</option>
              </select>
              <div className='srv-validation-message'>{Validator.message('vlm', plantData.vlm, 'vlm')}</div>
            </div>
          </div>
          <div className="column-three">
            <div className="form-group">
              <label>{LABLES.OrgCode}</label>
              <input type="text" name="orgCode" value={plantData.orgCode} onChange={(e) => handleChange(e)} className="form-control" placeholder={LABLES.OrgCode} />
              <div className='srv-validation-message'>{Validator.message('orgCode', plantData.orgCode, 'orgCode')}</div>
            </div>
          </div>
        </div>
        <div className="submition-outer"><button type='button' className="btn-prmry" onClick={(e) => handleUpdate(e, 2)}>{LABLES.ADDPLANT}</button></div>
      </div>
    </div>
  )
}

export default ConfigurePlant;